import { RawConfig, getConfig } from '../getConfig'
import { SourceFile } from 'ts-morph'

export async function transformImport(sourceFile: SourceFile, config: RawConfig): Promise<string> {
  if (!['.tsx', '.ts', '.jsx', '.js'].includes(sourceFile.getExtension())) {
    return sourceFile.getText()
  }

  const importDeclarations = sourceFile.getImportDeclarations()

  for (const importDeclaration of importDeclarations) {
    const moduleSpecifier = await updateImportAliases(importDeclaration.getModuleSpecifierValue(), config)

    importDeclaration.setModuleSpecifier(moduleSpecifier)
  }

  return sourceFile.getText()
}

async function updateImportAliases(moduleSpecifier: string, config: RawConfig): Promise<string> {
  if (!moduleSpecifier.startsWith('@/')) return moduleSpecifier

  if (moduleSpecifier.match(/^@\/registry\/ui/)) {
    return moduleSpecifier.replace(/^@\/registry\/ui/, config.aliases.ui ?? `${config.aliases.components}/ui`)
  }

  if (config.aliases.components && moduleSpecifier.match(/^@\/registry\/components/)) {
    return moduleSpecifier.replace(/^@\/registry\/components/, config.aliases.components)
  }

  if (config.aliases.animated && moduleSpecifier.match(/^@\/registry\/animated/)) {
    return moduleSpecifier.replace(/^@\/registry\/animated/, config.aliases.animated)
  }

  if (config.aliases.lib && moduleSpecifier.match(/^@\/registry\/lib/)) {
    return moduleSpecifier.replace(/^@\/registry\/lib/, config.aliases.lib)
  }

  if (config.aliases.hooks && moduleSpecifier.match(/^@\/registry\/(.+)\/hooks/)) {
    return moduleSpecifier.replace(/^@\/registry\/hooks/, config.aliases.hooks)
  }

  return moduleSpecifier.replace(/^@\/app\/registry\/(.+)\/components/, config.aliases.components)
}
